























import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class GenericButton extends Vue {
  @Prop() private classes!: string;
  @Prop({default: 'primary'}) private color!: string;
  @Prop({default: false}) private plain!: boolean;
  @Prop({default: false}) private text!: boolean;
  @Prop({default: false}) private icon!: boolean;
  @Prop({default: false}) private small!: boolean;
  @Prop({default: false}) private outlined!: boolean;
  @Prop({default: false}) private loading!: boolean;
  @Prop({default: false}) private isDisabled!: boolean;
  @Prop({default: false}) private block!: boolean;
  @Prop({default: true}) private ripple!: boolean;
  @Prop({default: 0}) private elevation!: number;
  @Prop() private height!: number;
  @Prop() private width!: number;

}
